import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl, StatusCode } from "api/protocols";
import { CancelToken } from "axios";

const adminType = "facility-admin";

interface IGetKitchenMeals {
  id: number;
}

export interface IKitchenMeal {
  id: number;
  facility_id: number;
  position: number;
  title: string;
}

interface IPostKitchenMeals {
  title: string;
}

interface IPutKitchenMeal {
  id: number;
  title: string;
}

export async function FireKitchenChit(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/kitchen/chit/fire"), params, useGlobalLoader);
}

export async function GetKitchenMeals(params: IGetKitchenMeals, useGlobalLoader?: boolean, token?: CancelToken) {
  return await APIGet<IKitchenMeal[]>(
    APIUrl(AdminType.FacilityAdmin, "/facility/kitchen/meal"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PostKitchenMeal(params: IPostKitchenMeals, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/kitchen/meal"), params, useGlobalLoader);
}

export async function PutKitchenMeal(params: IPutKitchenMeal, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/kitchen/meal"), params, useGlobalLoader);
}

export async function DeleteKitchenMeal(params: { id: number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/kitchen/meal"), params, useGlobalLoader);
}
